import { Button, Form, Input, message } from 'antd'
import { useState } from 'react'
import { Trans } from 'react-i18next'
import { useTranslation } from 'react-i18next'

import { API } from '@/api'
import EyeClose from '@/assets/icons/eye-close.svg?react'
import EyeOpen from '@/assets/icons/eye-open.svg?react'
import { Modal } from '@/components'
import { useUserStore } from '@/stores/user.ts'
interface PwChangeModal {
  onOk: () => void
  onClose: () => void
}

export function PwChangeModal(props: PwChangeModal) {
  const { onOk, onClose } = props
  const [form] = Form.useForm<any>()
  const [oriPassword, setOriPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPassword2, setNewPassword2] = useState('')
  const userStore = useUserStore()
  const { t } = useTranslation()
  const _onOK = async () => {
    try {
      await form.validateFields()
      const { code } = await API.updatePassword({
        name: userStore.account.name,
        ori_password: oriPassword,
        password: newPassword,
      })

      if (code === 0) {
        message.success('Password changed successfully')
        onOk()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
      className="w-[640px]"
      open={true}
      onClose={() => {
        onClose()
      }}
    >
      <Modal.Header>
        <Trans i18nKey="profile.pwChangeModal.title">Change Password</Trans>
      </Modal.Header>
      <Modal.Body>
        <div className="max-h-[540px] overflow-y-auto scrollbar-hide">
          <Form
            layout="vertical"
            form={form}
            initialValues={{ oriPassword: '', newPassword: '', newPassword2: '' }}
            validateTrigger="onBlur"
            scrollToFirstError
          >
            <Form.Item
              label={
                <div className="text-with-star">
                  <Trans i18nKey="profile.pwChangeModal.form.originalPw">Original Password</Trans>
                </div>
              }
              name="oriPassword"
              rules={[
                { required: true, message: t('profile.pwChangeModal.form.originalPwPlaceholder') },
              ]}
            >
              <Input.Password
                placeholder={t('profile.pwChangeModal.form.originalPwPlaceholder')}
                size="large"
                iconRender={(visible) => (visible ? <EyeOpen /> : <EyeClose />)}
                value={oriPassword}
                onChange={(e) => setOriPassword(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label={
                <div className="text-with-star">
                  <Trans i18nKey="profile.pwChangeModal.newPw">New Password</Trans>
                </div>
              }
              name="newPassword"
              rules={[
                { required: true, message: t('profile.pwChangeModal.form.newPwPlaceholder') },
              ]}
            >
              <Input.Password
                placeholder={t('profile.pwChangeModal.form.newPwPlaceholder')}
                size="large"
                iconRender={(visible) => (visible ? <EyeOpen /> : <EyeClose />)}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label={
                <div className="text-with-star">
                  <Trans i18nKey="profile.pwChangeModal.form.confirmPw">
                    New Password Confirmed
                  </Trans>
                </div>
              }
              name="newPassword2"
              rules={[
                { required: true, message: t('profile.pwChangeModal.form.confirmPwPlaceholder') },
                {
                  validator: (_, value) => {
                    if (value !== newPassword) {
                      return Promise.reject('The two passwords do not match')
                    }
                    return Promise.resolve()
                  },
                },
              ]}
            >
              <Input.Password
                placeholder={t('profile.pwChangeModal.form.confirmPwPlaceholder')}
                size="large"
                iconRender={(visible) => (visible ? <EyeOpen /> : <EyeClose />)}
                value={newPassword2}
                onChange={(e) => setNewPassword2(e.target.value)}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal.Body>
      <div>
        <div className="pt-4 flex items-end justify-end gap-4">
          <Button
            size="large"
            className="t-sb"
            onClick={() => {
              onClose()
            }}
          >
            <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
          </Button>
          <Button type="primary" size="large" className="t-sb" onClick={_onOK}>
            <Trans i18nKey="common.confirmModalOk">Confirm</Trans>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
